import {take, fork} from 'redux-saga/effects';
import {LOCATION_CHANGE} from 'connected-react-router';
import {getSnapshots} from '@pluto/rest';
import {payloadGenerator} from '@pluto/utils';
import {QCSnapshot, setSnapshotsAction, SnapshotStatus} from '../../SnapshotActions';

export const predicate = (data: QCSnapshot[]) => {
    return data.some((item) => item.status === SnapshotStatus.PENDING);
};

interface Props {
    type: string;
    videoFileId: number;
}

export function* fetchSnapShots(action: Props) {
    const {videoFileId} = action;

    const generator = yield fork(
        payloadGenerator,
        setSnapshotsAction,
        predicate,
        getSnapshots,
        videoFileId
    );

    yield take(LOCATION_CHANGE);

    generator.cancel();
}
